var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAluminium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.5 41.6",
    enableBackground: "new 0 0 32.5 41.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M.2 17.8V2.4L3 2S4.2-1.4 6.8.7l-.1 17.1H.2zM8.3.3l24.2 12.6v28.7L8.3 35.1zM6.5 19.7L6.6 35l-2.8.5S2.6 38.6 0 36.8l.1-17.1h6.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAluminium);
export default __webpack_public_path__ + "static/media/aluminium.2dc2ddb5e5e489c06d4892c830d96ad9.svg";
export { ForwardRef as ReactComponent };